import React, { useEffect, useState } from "react";
import "../../assets/styles/loader.css";
import Pagination from "../../Components/Pagination/Pagination";

import LocalLoader from "../../Components/Loader/LocalLoader.js";


import { TableWrapper } from "../../Components/styledConstant.js";
import { useNavigate } from "react-router-dom";
import FileUploadBox from "../../Components/UploadFile/FileUploadBox.jsx";
import { analyseUpload, getAnalyseList } from "../../utils/api.js";
import { isEmpty } from "../../utils/common.js";
import styled from "styled-components";
import { FilterWrapper } from "../../assets/styles/FilterStyle.js";
import { AlertWrapper } from "../../assets/styles/AlerWrapper.js";
import AnalyseDetails from "./AnalyseDetails.jsx";
import moment from "moment";

const formatAmount = (val) => {
  if (val === null || val === undefined) return "-";

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(val);
};
const mockdata = [{
    "processId": "9fcb8148-1cf9-43f5-8526-b6183fe7ccd1",
    "processData": "",
   
},
{
"processId": "96101386",
    "processData": "",
}
]


const Analyse = () => {
    const [loading, setLoading] = useState(false);
    const [settlementFile, setSettlementFile] = useState(null);
    const [transactionsFile, setTransactionsFile] = useState(null);
    const [errors, setErrors] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [msg, setMsg] = useState({});
    const [uploading, setUploading] = useState(false);
    const [list, setList] = useState([...mockdata]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalElements, setTotalElements] = useState(10);
    const [currPage, setCurrPage] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [processData,setProcessData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        getList()
    }, [])



    const getList = async (e, key = "") => {


        const param = {
               pagination:{
               pageNo: currPage,
               pageSize: pageSize,
    }
        };


        setLoading(true);

        getAnalyseList(param).then((resp) => {
            setLoading(false);

            if (resp?.data?.success) {
                setList(resp?.data?.data);
                // setTotalPages(resp?.data?.data?.totalPages);
                // setTotalElements(resp?.data?.data?.totalElements);
            }
        });
    };


    const uploadFile = () => {



        if (!settlementFile) {
            setErrors((prev) => ({ ...prev, settlementFile: "Please select settlement file" }));
        } else if (!transactionsFile) {
            setErrors((prev) => ({ ...prev, transactionsFile: "Please select transactions file" }));
        } else {
            const formData = new FormData();

            formData.append("transactionsFile", transactionsFile); // File object
            formData.append("settlementFile", settlementFile)

            setUploading(true);
            analyseUpload(formData).then((resp) => {
                setUploading(false)

                if (resp?.data?.success) {
                    setSettlementFile(null);
                    setTransactionsFile(null);
                    setIsOpen(false);
                    setMsg({
                        msg: resp?.data?.msg || "File Upload successfully",
                        type: "success",
                    });
                } else {
                    if (resp?.data?.errorCodeList.length > 0) {
                        setErrors((prev) => ({
                            ...prev,
                            response: resp?.data?.errorCodeList[0],
                        }));
                        setMsg({
                            msg: (resp?.data?.errorCodeList || []).join(","),
                            type: "error",
                        });
                    } else {
                        setMsg({
                            msg: resp?.data?.message || "Something went wrong. Please try again later.",
                            type: "error",
                        });

                    }

                    setTimeout(() => {
                        setMsg({});
                    }, 5000);
                }


            });
        }

    }



    const selectFile = (type, file) => {
        if (type === "settlementFile") {
            setSettlementFile(file);
            setErrors((prev) => ({ ...prev, settlementFile: "" }));
        } else {
            setTransactionsFile(file);
            setErrors((prev) => ({ ...prev, transactionsFile: "" }));
        }

    }


    return (
        <div style={{ padding: "30px" }}>
            <div>   {!isEmpty(msg) && (
                <AlertWrapper className={`${msg.type} globle`}>
                    <span className="close" onClick={() => setMsg({})}>
                        ×
                    </span>
                    {msg.msg}
                </AlertWrapper>
            )}
                {/* <div className="userlist_head">
          <div className="userlist_heading">
            <div className="userlist_left">
              <label>Analyse</label>
            </div>
     
       
          </div>
        </div> */}
                <FilterWrapper className={`display_data`} style={{marginTop:"40px"}}>
                    <div className="filterBox">
                        <div className="flex" style={{ width: "100%", justifyContent: "space-between" }}>
                            <h2 style={{ color: "#fff" }}>Analyse Report</h2>
                            <div className="button">
                                <button className="userlist_btn"

                                    onClick={(e) => setIsOpen(!isOpen)}
                                >Upload File</button>
                            </div >
                        </div>
                    </div>
                </FilterWrapper>
                {isOpen && <UploadWrapper>

                    <div className="uploadBox">
                        <span style={{ color: "#000" }}>Transactions File</span>
                        <FileUploadBox

                            onUploadFile={(file) => { selectFile("transactionsFile", file) }}
                            fileUpload={transactionsFile}
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                            style={{ width: "100%", maxWidth: "100%" }}
                        />
                        {errors?.transactionsFile && <span>{errors?.transactionsFile}</span>}
                    </div>

                    <div className="uploadBox">
                        <span style={{ color: "#000" }}>Settlement File</span>
                        <FileUploadBox
                            onUploadFile={(file) => { selectFile("settlementFile", file) }}
                            fileUpload={settlementFile}
                            style={{ width: "100%", maxWidth: "100%" }}   // ✅ correct
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                        />
                        {errors?.settlementFile && <span>{errors?.settlementFile}</span>}
                    </div>

                    <button
                        className="saveBtn"
                        onClick={()=>uploadFile()}
                        disabled={!transactionsFile || !settlementFile || uploading}
                    >
                        {uploading ? "Uploading" : "Upload"}
                    </button>

                </UploadWrapper>}


            </div>



            {(

                <div className="table-loader">
                    {loading && <LocalLoader className="tableLoader" />}
                    <TableWrapper className="table-card-wrapper">
                        <table className="table custom-table">
                            <thead>
                                <tr>
                                    <th style={{ width: "60px" }}>S.No</th>
                                    <th>Process ID</th>
                                    <th>Process Date</th>
                                    <th>Process Size</th>
                                   
                                    <th style={{ width: "120px" }}>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {list?.map((item, i) => (
                                    <tr key={item.terminalId}>
                                        <td>{currPage * pageSize + i + 1}</td>

                                        <td className="text-ellipsis">{item?.processId}</td>
                                        <td className="text-ellipsis">{item?.processDate?moment(item?.processDate).format("DD MMM YYYY, hh:mm A"):""}</td>
                                        <td className="text-ellipsis">{item?.recordSize}</td>


                                        <td className="user_action_btn">
                                            <button style={{ marginRight: "5px" }}>
                                                <i
                                                    className="fa-regular fa-eye"
                                                    onClick={() => setProcessData(item)}
                                                />
                                            </button>

                                            {/* <button>
                                                <i
                                                    className="fa-solid fa-download"
                                                    onClick={() => console.log("Download", item)}
                                                />
                                            </button> */}
                                        </td>
                                    </tr>
                                ))}

                                {!loading && list.length < 1 && (
                                    <tr>
                                        <td colSpan={7} style={{ textAlign: "center", color: "red" }}>
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </TableWrapper>
                </div>
            )}
            {totalPages > 1 && (
                <Pagination
                    items={list}
                    itemsPerPage={10}
                    setitemsPerPage={setPageSize}
                    currentPage={1}
                    setcurrentPage={setCurrPage}
                    totalPages={setTotalPages}
                />
            )}
            {processData &&<AnalyseDetails
            onClose={()=>setProcessData(null)}
            data={processData}
             />}
        </div>
    );
};

export default Analyse;




export const UploadWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  .uploadBox {
    max-width: calc(50% - 10px);
    width: calc(50% - 10px);
  }

  .saveBtn {
    height: 42px;
    padding: 0 20px;
    background-color: #2563eb;
    color: #fff;
    border: none;
    border-radius: 8px;
    cursor: pointer;
  }

  .saveBtn:hover {
    background-color: #1d4ed8;
  }

  .saveBtn:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
  }
`;